import { Component, OnInit, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SettingsConstants } from 'projects/is-ui-kit/src/lib/core/settings/settings.service';

@Component({
  selector: 'is-create-frame',
  templateUrl: './create-frame.component.html',
  styleUrls: ['./create-frame.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateFrameComponent implements OnInit {

  @Input() currentDataExperience: any = {};
  @Output() public selected = new EventEmitter();
  @Input() public item;
  @Input() public position;
  @Input() public worldsList: any = [];
  public framesList: any = [];
  public framesOptions = [];
  public showWorld = true; // show the "choose world section"
  public selectedWorld;
  public keyList = [];
  public searchComponentControl = new UntypedFormControl();
  // a list with all filtered frames, frames list contains the entire list, this one contains only frames according to the searched value
  public filteredFramesOptions: Observable<any[]>;
  public isNative: boolean = null; // null because in template i have to comprare == false

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    // setup filters
    this.filteredFramesOptions = this.searchComponentControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );

    this.isNative = this.currentDataExperience.is_native;
  }

  /** filter method */
  private _filter(value: string): string[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.framesOptions.filter((option) => option.framenamedescr.toLowerCase().includes(filterValue));
    }
  }

  /** get current data experience detail */
  public getDataExperienceDetail(): void {
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/data_experience/${this.currentDataExperience.id}/`;
    const sub = this.http.get(url).subscribe({
      next: (data) => {
        this.currentDataExperience = data;
      },
      error: () => {
        setTimeout(() => {
          sub.unsubscribe();
        });
      },
      complete: () => {
        setTimeout(() => {
          sub.unsubscribe();
          this.isNative = this.currentDataExperience.is_native;
        });
      },
    });
  }

  /** get frames */
  public getFrames(appName): void {
    const queryParams = `?app_name=${appName}`;
    const sub = this.http.get(`${SettingsConstants.BACKENDURL}/api/dataxp/v1/getframeslist/${queryParams}`).subscribe({
      next: (data) => {
        this.framesList = data;
      },
      error: () => {
        setTimeout(() => {
          sub.unsubscribe();
        });
      },
      complete: () => {
        setTimeout(() => {
          sub.unsubscribe();
          // FIXME: temporaneo
          const temp = [];
          for (const key of Object.keys(this.framesList)) {
            for (const element of this.framesList[key]) {
              element.key = key;
              this.framesOptions.push(element);
            }
            temp.push(key);
          }
          this.keyList = [...new Set(temp)];
        });
      }
    });
  }

  /** set correct color to hover icons */
  public setColor(element, world, enter = true): void {
    element = element.currentTarget;
    if (enter) { // on mousehover
      element.style.color = world.color;
      element.style.backgroundColor = world.light_color;
    } else { // mouse leave
      element.style.color = '#666666';
      element.style.backgroundColor = '#f6f6f6';
    }
  }

  /** triggered after a world has been clicked */
  public chooseComponent($event, world): void {
    this.showWorld = false; // show the choose component select list
    this.selectedWorld = world;
    if (world.be_app_name) {
      this.getFrames(world.be_app_name);
    }
  }

  /** emit event method */
  public selectedFrame(frame): void {
    const frameToPost: any = {};
    frameToPost.name = `frame ${moment().toISOString()}`;
    frameToPost.dataxp = this.currentDataExperience.id;
    frameToPost.module = this.selectedWorld.dataxpfe_app_name;
    frameToPost.contest = this.selectedWorld.world_name;
    frameToPost.type = frame.framename;
    frameToPost.position = this.position;
    // setting up the configuration json property
    frameToPost.configuration = {};
    frameToPost.configuration = JSON.stringify(frameToPost.configuration);
    frameToPost.configuration = frameToPost.configuration.replace(/\\n/g, '');
    frameToPost.configuration = frameToPost.configuration.replace(/\\/g, '');

    const sub = this.http.post(`${SettingsConstants.BACKENDURL}/api/dataxp/v1/frame/`, frameToPost).subscribe({
      next: () => { },
      error: () => {
        setTimeout(() => {
          sub.unsubscribe();
        });
      },
      complete: () => {
        setTimeout(() => {
          sub.unsubscribe();
          this.selected.emit();
        });
      },
    });
  }
}
